<template>
  <div
    class="shareon"
    :data-url="`${origin}?group=${encodeURIComponent(GroupLabel ?? '')}&data=${getCompressedCSV}`"
    data-hashtags="UnfairSpinWheel"
    data-text="Hey there! I just found this fun spin wheel and thought you might enjoy it too. Check it out here!"
    v-tooltip.bottom="{
      value: `Share your spin wheel with your friends!`,
      class: 'text-sm',
      escape: true
    }"
  >
    <a class="mastodon"></a>
    <a class="twitter"></a>
    <a class="facebook"></a>
    <a class="pocket"></a>
    <a class="reddit"></a>
    <a class="teams"></a>
    <a class="telegram"></a>
    <a class="copy-url"></a>
  </div>
</template>

<script lang="ts" setup>
import { nextTick, onMounted, ref, watch } from 'vue';
import { init } from 'shareon';
import { GroupLabel, Items } from '@/services/ItemService';
import { StringHelper } from '@/helpers/StringHelper';
import type { IItem } from '@/interface/IItem';

const origin = window.location.origin;

const getCompressedCSV = ref('');

// Update to accept IItem[] instead of PouchDB types
const updateShareLink = (newItems: IItem[] | undefined) => {
  if (newItems && newItems.length > 0) {
    // Transform items to CSV-friendly format if needed
    const csvData = StringHelper.csvStringify(newItems);
    getCompressedCSV.value = StringHelper.compress(csvData);
  } else {
    getCompressedCSV.value = '';
  }
};

onMounted(async () => {
  // Watch for changes in getCompressedCSV and re-initialize shareon
  watch(getCompressedCSV, () => {
    // Re-initialize shareon after the compressed CSV updates
    nextTick(() => {
      init();
    });
  });

  // Watch for changes in Items array
  watch(
    Items,
    (newItems) => {
      updateShareLink(newItems);
    },
    { deep: true }
  ); // Deep watch to catch changes within items

  // Initial update
  updateShareLink(Items.value);

  await nextTick();
  init();
});
</script>

<style scoped></style>
